/** Оглавление шага «на странице» (S4): якорь, подпись, счётчик из данных. */
export type TocItem = { href: string; label: string; count?: string; active?: boolean; done?: boolean };

export function Toc({ items, eyebrow = "на странице" }: { items: TocItem[]; eyebrow?: string }) {
  return (
    <nav aria-label={eyebrow} className="flex flex-col gap-1">
      <div className="mb-1 font-mono text-[10.5px] uppercase tracking-[.06em] text-mut">{eyebrow}</div>
      {items.map((it) => (
        <a
          key={it.href}
          href={it.href}
          className={`flex items-center gap-2 rounded-sm px-2 py-1.5 font-mono text-[12px] no-underline ${it.active ? "bg-accsoft text-acc" : "text-ink2 hover:bg-card2"}`}
        >
          <span aria-hidden className={it.done ? "text-ok" : it.active ? "text-acc" : "text-mut"}>
            {it.done ? "✓" : "○"}
          </span>
          <span className="flex-1">{it.label}</span>
          {it.count && <span className={it.active ? "text-ink2" : "text-mut"}>{it.count}</span>}
        </a>
      ))}
    </nav>
  );
}
